import _ from "lodash";
import { useState, useEffect } from "react";
import { template as tmpl } from "./template";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE } from "@/config/constants";
import { requestOTPResetPassword, verifyOTPResetPassword } from "@/stores/apis/apiAuth";

const ConfirmOTP = ({ payload = {}, onConfirmOTPSuccess, onSendOTPAgainSuccess, expiredDate, onBack, errors }) => {
	const { method = "" } = payload;

	const [countDown, setCountDown] = useState(0);
	const [loading, setLoading] = useState(false);
	const [otp, setOtp] = useState("");

	useEffect(() => {
		if (expiredDate) {
			const countDownDate = new Date(expiredDate).getTime();
			const interval = setInterval(() => {
				setCountDown(countDownDate - new Date().getTime());
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [expiredDate]);

	const sendCodeAgain = async () => {
		if (!payload || loading) {
			return;
		}
		setLoading(true);
		let rs = await requestOTPResetPassword(payload);
		if (rs && rs.success) {
			onSendOTPAgainSuccess?.();
			toast({
				type: NOTIFICATION_TYPE.SUCCESS,
				description: "OTP Resent Successfully!",
			});
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Resend OTP Failed!",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 300);
	};

	const onConfirmOTP = async () => {
		if (!otp) {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Invalid OTP.",
			});
			return;
		}

		if (loading) return;
		setLoading(true);

		let data = { ...payload, otp: otp };
		const rs = await verifyOTPResetPassword(data);
		if (rs && rs.success) {
			onConfirmOTPSuccess?.(data);
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "OTP Incorrect.",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 200);
	};

	const handleChangeOtp = (otp) => {
		setOtp(otp);
	};

	const initProps = {
		method: method,
		errors: errors,
		payload: payload,
		otp: otp,
		setOtp: setOtp,
		countDown,
		handleChangeOtp: handleChangeOtp,
		sendCodeAgain,
		onConfirmOTP,
		onBack,
		loading,
	};
	return tmpl && tmpl({ ...initProps });
};

export default ConfirmOTP;
